import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { setTokenProvider } from "./api/client";
import { App } from "./app";
import { createFirebaseAuth, firebaseSession } from "./platform/firebase";
import "./styles.css";

const root = document.getElementById("root");
if (!root) throw new Error("#root missing");

const session = firebaseSession(createFirebaseAuth());
setTokenProvider(session.token);

createRoot(root).render(
  <StrictMode>
    <BrowserRouter>
      <App session={session} />
    </BrowserRouter>
  </StrictMode>,
);
